import React from 'react';

export const ThinkingEmoji = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="thinkingEmojiT">thinking emoji</title>
            <desc id="thinkingEmojiD">
                A vector illustration of a thinking emoji
            </desc>
            <path
                d="M13.147 0c5.621 0 10.178 4.557 10.178 10.178 0 5.62-4.557 10.177-10.178 10.177-5.62 0-10.178-4.558-10.178-10.177C2.97 4.557 7.526 0 13.147 0Z"
                fill="#FD0"
            />
            <path
                d="M20.274 4.087c.012-.069-.057-.192-.057-.192s-.744-.907-1.805-1.324c-1.06-.417-1.828-.396-2.37-.17-.562.235-1.242.773-.898 1.597.18.432.583.248 1.024.134.441-.115 1.784-.61 3.808.038.218.07.283-.003.298-.083ZM6.29 3.901c-.032-.062 0-.2 0-.2S6.742 2.62 7.64 1.917c.899-.702 1.637-.9 2.223-.839.606.065 1.411.386 1.316 1.274-.05.465-.487.404-.943.422C9.78 2.792 8.353 2.7 6.598 3.9c-.188.127-.272.075-.309.002Z"
                fill="#1E1E1E"
            />
            <path
                d="M17.32 11.301c1.746 0 3.162-1.565 3.162-3.496s-1.416-3.497-3.163-3.497c-1.746 0-3.162 1.566-3.162 3.497 0 1.93 1.416 3.496 3.162 3.496Z"
                fill="#EF790F"
            />
            <path
                d="M17.273 11.18c1.661 0 3.007-1.465 3.007-3.273 0-1.807-1.346-3.272-3.007-3.272-1.66 0-3.007 1.465-3.007 3.272 0 1.808 1.347 3.273 3.007 3.273Z"
                fill="#fff"
            />
            <path
                d="M16.644 8.105c.861 0 1.56-.724 1.56-1.618 0-.894-.699-1.619-1.56-1.619-.861 0-1.56.725-1.56 1.619s.699 1.618 1.56 1.618Z"
                fill="#1E1E1E"
            />
            <path
                d="M16.644 7.872c.737 0 1.335-.62 1.335-1.385 0-.766-.598-1.386-1.335-1.386s-1.334.62-1.334 1.386c0 .765.597 1.385 1.334 1.385Z"
                fill="#88D5FF"
            />
            <path
                d="M16.644 7.343c.456 0 .826-.383.826-.856s-.37-.857-.826-.857c-.456 0-.825.384-.825.857s.37.856.825.856Z"
                fill="#1E1E1E"
            />
            <path
                d="M17.386 6.33a.59.59 0 1 0 0-1.182.59.59 0 0 0 0 1.182ZM16.445 7.44a.253.253 0 1 0 0-.505.253.253 0 0 0 0 .506Z"
                fill="#fff"
            />
            <path
                d="M8.975 11.301c1.746 0 3.162-1.565 3.162-3.496s-1.416-3.497-3.162-3.497c-1.747 0-3.163 1.566-3.163 3.497 0 1.93 1.416 3.496 3.163 3.496Z"
                fill="#EF790F"
            />
            <path
                d="M9.021 11.18c1.66 0 3.007-1.465 3.007-3.273 0-1.807-1.346-3.272-3.007-3.272-1.66 0-3.007 1.465-3.007 3.272 0 1.808 1.346 3.273 3.007 3.273Z"
                fill="#fff"
            />
            <path
                d="M8.565 8.105c.861 0 1.56-.724 1.56-1.618 0-.894-.699-1.619-1.56-1.619-.861 0-1.56.725-1.56 1.619s.699 1.618 1.56 1.618Z"
                fill="#1E1E1E"
            />
            <path
                d="M8.565 7.872c.737 0 1.335-.62 1.335-1.385C9.9 5.72 9.302 5.1 8.565 5.1s-1.335.62-1.335 1.386c0 .765.598 1.385 1.335 1.385Z"
                fill="#88D5FF"
            />
            <path
                d="M8.565 7.343c.456 0 .825-.383.825-.856s-.37-.857-.825-.857c-.456 0-.825.384-.825.857s.37.856.825.856Z"
                fill="#1E1E1E"
            />
            <path
                d="M9.306 6.33a.59.59 0 1 0 0-1.182.59.59 0 0 0 0 1.182ZM8.366 7.44a.253.253 0 1 0 0-.505.253.253 0 0 0 0 .506Z"
                fill="#fff"
            />
            <path
                d="M16.087 15.922a.806.806 0 0 1-.627-.297c-.534-.656-1.371-1.044-2.489-1.155a6.422 6.422 0 0 0-.638-.031 6.304 6.304 0 0 0-.998.075.808.808 0 0 1-.296-1.59 7.58 7.58 0 0 1 1.296-.103c2.416 0 3.714.97 4.378 1.781a.808.808 0 0 1-.626 1.319v.002Z"
                fill="#EF790F"
            />
            <path
                d="M16.087 15.651a.536.536 0 0 1-.416-.197c-.582-.713-1.48-1.135-2.672-1.254a6.805 6.805 0 0 0-1.711.047.537.537 0 0 1-.199-1.055c.146-.028 3.594-.649 5.414 1.583a.537.537 0 0 1-.416.876Z"
                fill="#1E1E1E"
            />
            <path
                d="M6.281 24c-2.824 0-3.852-1.587-4.212-2.531-1.147-3.008.5-4.4 1.29-5.068.114-.097.212-.18.282-.25.502-.502.65-1.554.312-2.207-.174-.335-.168-.699.014-.998a1.098 1.098 0 0 1 .937-.512 1.203 1.203 0 0 1 .887.406c1.163 1.265 1.363 2.614.596 4.016l6-1.369a1.126 1.126 0 0 1 .535 2.184l-2.824.742c.15.21.232.46.238.718 0 .32-.131.62-.397.89.156.2.313.49.29.832-.02.305-.172.58-.455.819.105.17.16.366.156.566-.008.375-.225.721-.645 1.026-.501.368-1.694.736-3.004.736Z"
                fill="#EF790F"
            />
            <path
                d="m6.05 17.279 6.412-1.463a.788.788 0 0 1 .375 1.528l-3.375.885s1.218.873-.014 1.772c0 0 1.107.858-.166 1.606 0 0 .816.65-.194 1.385-1.011.734-5.484 1.551-6.703-1.646-1.218-3.198.886-4.347 1.493-4.956.607-.61.776-1.831.375-2.604-.4-.774.652-1.41 1.289-.719.602.656 1.626 2.028.34 3.968a.16.16 0 0 0 .168.244Z"
                fill="#fff"
            />
            <path
                d="M6.05 17.28s-.58.338-.696 1.03c0 0 0-.953.528-1.278a.16.16 0 0 0 .168.247ZM9.446 20.003s.027.02.068.06c-.397-.02-1.226.077-1.226.077s.472-.301 1.28-.235c-.037.034-.078.064-.122.098ZM9.352 21.677a5.588 5.588 0 0 0-.703-.052s.45-.176.793-.12a1.92 1.92 0 0 1-.16.104.834.834 0 0 1 .07.068ZM9.46 18.23c.042.033.083.068.123.105-.474-.064-1.076-.023-1.076-.023s.619-.221 1.186-.14l-.234.059Z"
                fill="#EF790F"
            />
        </svg>
    );
};
